import { useEffect } from 'react';

// credit: https://github.com/jeetiss/react-pdf-repl/blob/main/app/repl.js for the idea
export const createSingleton = <T>(
  constructor: () => T,
  destructor: (instance: T) => void
) => {
  const ref: {
    instance?: T;
    timeout?: NodeJS.Timeout;
    usageCount?: number;
  } = {};

  return () => {
    if (!ref.instance) {
      ref.instance = constructor();
    }

    useEffect(() => {
      if (ref.timeout) {
        clearTimeout(ref.timeout);
        delete ref.timeout;
      } else {
        ref.usageCount = (ref.usageCount ?? 0) + 1;
      }

      return () => {
        ref.timeout = setTimeout(() => {
          ref.usageCount = (ref.usageCount ?? 1) - 1;

          if (ref.usageCount === 0) {
            if (ref.instance) {
              destructor(ref.instance);
            }
            delete ref.instance;
            delete ref.timeout;
          }
        });
      };
    }, []);

    return ref.instance;
  };
};
